// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset CSS minimale
const style = document.createElement('style');
style.textContent = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { -webkit-font-smoothing: antialiased; }
  button:disabled { cursor: not-allowed; }
  input[type="date"]::-webkit-calendar-picker-indicator { cursor: pointer; }
  @media (max-width: 600px) {
    /* Mobile: frecce più grandi, font leggermente ridotti */
    h2 { font-size: 20px !important; }
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
